import { addNewClient } from './../../../config/redux/clients/clientsActions';
import React from 'react'
import { connect, RootStateOrAny } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { getCompanies } from "../../../connectors/clients/connectors/index";
import { reloadData } from "../../../config/redux/clients/clientsActions";
import { filter, setFinished, sort, toggleFiltration } from "../../../config/redux/filters/filterActions"
import { IPaginationProps, IPaginationState } from "./pagination.types";
import { getParams } from "../actions/getClientsParams"
import { generateItems } from "../actions/generateClients"
import { AxiosResponse } from 'axios';
import { setListMessage } from '../../../config/redux/alerts/alertsActions';

class Pagination extends React.Component<IPaginationProps, IPaginationState> {
  private _data: any = [];

  footerRef = React.createRef<HTMLDivElement>();

  state = {
    data: [],
    limit: 35,
    total: 0,
    page: 1,
    loading: false,
  };

  async componentDidMount() {
    await this.props.dispatch(sort({ column: undefined }));
    await this.props.dispatch(toggleFiltration({ filter: false }))
    await this.props.dispatch(filter({ searchPhrase: undefined, searchFields: undefined, searchMode: undefined }));
    await this.props.dispatch(setFinished({ finished: false }));

    if (this.props.footerRef.current !== null) {
      this._observer.observe(this.props.footerRef.current);
    }

    this._setClients();
  }

  componentDidUpdate(prevProps: IPaginationProps) {
    const { reload, searchPhrase, filter, add, column, dispatch } = this.props

    if (reload) {
      this._reload();
      this._removeItems();
    }

    if (filter == true) {
      this._reload();
      if (column) {
        this._filterClients(searchPhrase, column.key, column.isSortedDescending)
      }
      else {
        this._filterClients(searchPhrase)
      }

      dispatch(toggleFiltration({ filter: false }))
    }

    if (add) {
      this._setClients(1);
      dispatch(addNewClient(false))
    }
  }

  componentWillUnmount() {
    if (this.props.footerRef.current !== null) {
      this._observer.unobserve(this.props.footerRef.current);
    }
  }

  private _handleObserver = (entry: any, observer: any) => {
    if (this.props.finished == false) {
      return;
    }

    if (this.state.data.length < this.state.total) {
      this._setClients();
    }
  };

  private _observer = new IntersectionObserver(this._handleObserver, {
    root: null,
    rootMargin: "100px",
    threshold: 1,
  });

  private _reload = async () => {
    this.props.dispatch(reloadData({ reload: false }));
  };

  private _removeItems = () => {
    const clients = _.remove(this.state.data, (client: any) => {
      if (!this.props.selectedClients.includes(client.id)) {
        return client;
      }
    });

    this.setState({ data: [...clients] });
  };


  private _filterClients = async (searchPhrase: string, orderBy: undefined | string = undefined, desc: undefined | boolean = false) => {
    this.props.dispatch(setFinished({ finished: false })); 
    
    const { limit } = this.state;
    const params = getParams(this.props.location.pathname);
    const searchParams = { searchPhrase, searchFields: this.props.searchFields, searchMode: this.props.searchMode };

    var res: AxiosResponse<any>;
    if (orderBy !== undefined) {
      res = await getCompanies({ page: 1, limit, ...params, ...searchParams, OrderBy: orderBy, Desc: desc });
    }
    else {
      res = await getCompanies({ page: 1, limit, ...params, ...searchParams });
    }
    this.props.dispatch(setListMessage(`Znaleziono ${res.data.total} klientów`));
    const clients = generateItems(res.data.data);
    this.setState((prevState: IPaginationState) => {
      return {
        data: [...clients],
        page: 2,
        total: res.data.total,
      };
    });
    this.props.dispatch(setFinished({ finished: true }));
  }

  private _setClients = async (newPage?: number) => {
    const { searchPhrase, column, searchFields, searchMode } = this.props;
    const { limit, page } = this.state;
    const params = getParams(this.props.location.pathname);
    const p = newPage ? newPage : page;
    let res: any;
    // this.setState({loading: true})
    this.props.dispatch(setFinished({ finished: false }));
    if (column) {
      res = await getCompanies({ page: p, limit, ...params, OrderBy: column.key, Desc: column.isSortedDescending, searchPhrase, searchFields, searchMode });
    } else {
      res = await getCompanies({ page: p, limit, ...params, searchPhrase, searchFields, searchMode });
    }
    const clients = generateItems(res.data.data);
    this.setState((prevState: IPaginationState) => {
      return {
        data: newPage ? [...clients] : [...prevState.data, ...clients],
        page: newPage ? newPage : prevState.page + 1,
        total: res.data.total,
        // loading: false
      };
    });
    this.props.dispatch(setFinished({ finished: true }));
  };

  public render() {
    const renderProps = {
      data: this.state.data,
      loading: this.state.loading
    };

    return this.props.render(renderProps);
  }
}

const mapStateToProps = (state: RootStateOrAny) => {
  return {
    reload: state.clients.reload,
    add: state.clients.addNewClient,
    searchPhrase: state.filtration.searchPhrase,
    searchFields: state.filtration.searchFields,
    searchMode: state.filtration.searchMode,
    selectedClients: state.clients.selectedClients,
    filter: state.filtration.filter,
    column: state.filtration.column,
    finished : state.filtration.finished
  };
};

export default connect(mapStateToProps)(withRouter(Pagination));